import { accessToken } from '@carvana/core-auth';
import { datadogRum } from '@datadog/browser-rum';
import { v4 as uuid } from 'uuid';
import { appVersion, environment, isProd } from '~/constants/environment';
import { BrowserCookies, getUserId } from '~/utilities';
import isBotUserAgent from '~/utilities/isBotUserAgent';
import {
  loadItemFromSessionStorage,
  saveItemToSessionStorage
} from '~/utilities/sessionStorage';

function log(status: 'imported' | 'initializing' | 'ready') {
  if (isProd) return;

  console.debug(`DataDog is ${status}`, performance.now());
}

const unwantedViewNames = ['/managepurchase', '/managecustomer'];

log('imported');

export default function initDataDog(
  correlationId?: string,
  sampleRate: number = 10,
  replaySampleRate: number = 10
) {
  log('initializing');
  const isAuthUser = accessToken().isValidToken;
  const isBot = isBotUserAgent(navigator.userAgent);
  const unauthSampleRate = isBot ? 0 : sampleRate;
  const unauthReplaySampleRate = isBot ? 0 : replaySampleRate;

  datadogRum.init({
    applicationId: 'b1337a69-f11e-4206-a2ef-4b273beea1cb',
    clientToken: 'pubc4dcb379da198c6154be75c113e30243',
    env: environment,
    sessionSampleRate: isAuthUser ? 100 : unauthSampleRate,
    sessionReplaySampleRate: isAuthUser ? 100 : unauthReplaySampleRate,
    site: 'datadoghq.com',
    service: 'merch-ui',
    version: appVersion,
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [
      'https://apps.carvana.io',
      'https://apik.carvana.io',
      'https://apps.carvanatech.com',
      'https://apik.carvanatech.com'
    ],
    beforeSend: event => {
      const url = new URL(event.view.url);

      return !unwantedViewNames.includes(url.pathname);
    }
  });

  datadogRum.onReady(() => {
    log('ready');
  });

  datadogRum.setUser({
    browserCookieId: BrowserCookies.get('BrowserCookieId'),
    id: getUserId()
  });

  if (correlationId) {
    datadogRum.setGlobalContextProperty('correlationId', correlationId);
  }

  const getTabId = () => {
    const existingTabId = loadItemFromSessionStorage<string>('dd_tab_id');

    if (existingTabId) {
      return existingTabId;
    }

    const newTabId = uuid();
    saveItemToSessionStorage('dd_tab_id', newTabId);

    return newTabId;
  };

  datadogRum.setViewContextProperty('tab_id', getTabId());
}

export const updateDataDogContext = (key: any, value: any) => {
  datadogRum.setGlobalContextProperty(key, value);
};
